import IconSelectDragReorderDots from "@shared/components/icons/SelectDragReorderDots"
import { cx } from "@shared/components/untitledui/util/cx"
import type { HTMLAttributes, Ref } from "react"

/**
 * The drag grip button — the mouse move pad AND the keyboard/screen-reader affordance to start a
 * lesson drag. Rendered in the lesson body's title gutter (a slot with no body has nothing to drag).
 */
export default function LessonDragGrip({
  className,
  ref,
  ...dragProps
}: HTMLAttributes<HTMLDivElement> & { ref: Ref<HTMLDivElement> }) {
  return (
    <div
      ref={ref}
      {...dragProps}
      role="button"
      tabIndex={0}
      data-test="lesson drag grip"
      aria-label="Drag to move lesson"
      className={cx(
        // The icon (and its 14px size) match the card drag handles (DragHandle.tsx).
        // grab → grabbing while pressed: the hand closes the moment you pick the lesson up.
        // (Once the native drag is in flight the BROWSER owns the cursor — CSS can't reach it.)
        "flex cursor-grab items-center justify-center leading-none select-none active:cursor-grabbing [&_svg]:pointer-events-none [&_svg]:h-3.5 [&_svg]:w-auto",
        className,
      )}
    >
      <IconSelectDragReorderDots />
    </div>
  )
}
